import { Emitter } from "tu-emitter"

export const emitter = new Emitter()
